module.exports = __webpack_public_path__ + "static/media/pluseIcon.c318256e.svg";